import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../view/Login'
import Register from '../view/Register'
import Home from '../view/Home'
import { isLoggedIn } from '../api/auth'
import ShenbaoLogin from "../view/ShenbaoLogin";

// 安装路由
Vue.use(VueRouter);

// 配置导出路由
const router = new VueRouter({
  mode: 'history',
  routes: [{
    path: "/",
    redirect: "/h5/chat"
  },
  {
    name: "Login",
    path: '/login',
    component: Login
  },
    {
      name: "ShenbaoLogin",
      path: '/shenbaologin',
      component: ShenbaoLogin
    },
  // {
  //   name: "Register",
  //   path: '/register',
  //   component: Register
  // },
  {
    name: "Home",
    path: '/home',
    component: Home,
    children: [
      {
        name: "Chat",
        path: "/home/chat",
        component: () => import("../view/Chat"),
      },
      {
        name: "Friend",
        path: "/home/friend",
        component: () => import("../view/Friend"),
      },
      {
        name: "GROUP",
        path: "/home/group",
        component: () => import("../view/Group"),
      }
    ]
  },
  {
    name: "H5Chat",
    path: '/h5/chat',
    component: () => import("../view/H5Chat"),
  }
  ]

});

const whiteList = ['/login', '/shenbaologin', '/h5/chat', '/login/demo', '/password/reset'];

router.beforeEach((to, from, next) => {
  if (whiteList.includes(to.path) || isLoggedIn()) {
    next();
  } else {
    next('/login');
  }
});


export default router;